import React from "react";
import resumeFile from "../documents/RiteshMistri.pdf";
const AboutUs = ({ classicHeader, darkTheme }) => {
  return (
    <section id="about" className={"section " + (darkTheme ? "bg-dark-1" : "")}>
      <div className={"container " + (classicHeader ? "" : "px-lg-5")}>
        {/* Heading */}
        <div className="position-relative d-flex text-center mb-5">
          <h2
            className={
              "text-24  text-uppercase fw-600 w-100 mb-0 " +
              (darkTheme ? "text-muted opacity-1" : "text-light opacity-4")
            }
          >
            About Me
          </h2>
          <p
            className={
              "text-9 text-dark fw-600 position-absolute w-100 align-self-center lh-base mb-0 " +
              (darkTheme ? "text-white" : "text-dark")
            }
          >
            Know Me More
            <span className="heading-separator-line border-bottom border-3 border-primary d-block mx-auto" />
          </p>
        </div>
        {/* Heading end*/}
        <div className="row gy-5">
          {/* About me content start */}
          <div className="col-lg-7 col-xl-8 text-center text-lg-start">
            <h2
              className={
                "text-7 fw-600 mb-3 " + (darkTheme ? "text-white" : "")
              }
            >
              I'm <span className="text-primary">Ritesh Mistri,</span> Senior Full Stack Developer & Manager
            </h2>
            <p className={darkTheme ? "text-white-50" : ""}>
              Welcome to the digital realm of Ritesh Mistri, a seasoned Senior Full Stack Developer and Team Lead, whose passion for crafting dynamic and scalable web applications has propelled him to the forefront of the technology industry.
            </p> <p className={darkTheme ? "text-white-50" : ""}>
              With over 8 years of hands-on experience, Ritesh has honed his skills in an array of cutting-edge technologies, specializing in both front-end and back-end development. His journey began in the vibrant city of Surat, where he embarked on a quest to redefine the landscape of web development.
            </p> <p className={darkTheme ? "text-white-50" : ""}>
              Throughout his illustrious career, Ritesh has left an indelible mark on the digital landscape, spearheading a myriad of groundbreaking projects that have revolutionized industries and redefined user experiences. From architecting sophisticated web portals to developing intuitive mobile applications, Ritesh's innovative solutions have garnered acclaim for their ingenuity and effectiveness.
            </p> <p className={darkTheme ? "text-white-50" : ""}>
              A true maestro of his craft, Ritesh is adept in a plethora of programming languages and frameworks, including CorePHP, Laravel, ReactJs, Python-Django, and more. His technical prowess is matched only by his exceptional leadership skills, having served as a Project Manager and Team Lead for esteemed organizations such as Bluehole(OPC) PVT. LTD. and Kautilyam.
            </p> <p className={darkTheme ? "text-white-50" : ""}>
              Driven by an insatiable thirst for knowledge and a relentless pursuit of excellence, Ritesh is committed to staying at the forefront of technological innovation. His dedication to continuous learning is underscored by a myriad of certifications, including Microsoft Technology Associate and React Bootcamp, among others.
            </p> <p className={darkTheme ? "text-white-50" : ""}>
              But beyond the realm of code and algorithms lies a passionate individual driven by a vision to make a difference. Ritesh believes in the transformative power of technology to drive positive change and empower individuals and businesses alike. His mission is simple yet profound: to leverage technology as a catalyst for progress, innovation, and human empowerment.
            </p> <p className={darkTheme ? "text-white-50" : ""}>
              Join Ritesh on a journey of exploration, innovation, and boundless possibilities as he continues to push the boundaries of what's possible in the ever-evolving world of technology.            </p>
            {/* <p className={darkTheme ? "text-white-50" : ""}>
              Delivering work within time and budget which meets client’s
              requirements is our moto. Lorem Ipsum has been the industry's
              standard dummy text ever when an unknown printer took a galley.
            </p> */}
          </div>
          {/* About me content end */}
          {/* about me personal detials start */}
          <div className="col-lg-5 col-xl-4">
            <div className="ps-lg-4">
              <ul
                className={
                  "list-style-2 " +
                  (darkTheme ? "list-style-light text-light" : "")
                }
              >
                <li>
                  <span className="fw-600 me-2">Name:</span>Ritesh Mistri
                </li>
                <li>
                  <span className="fw-600 me-2">Email:</span>
                  <a href="mailto:chat@simone.com">ritesh.developer@gmail.com</a>
                </li>
                {/* <li>
                  <span className="fw-600 me-2">Age:</span>28
                </li> */}
                <li className="border-0">
                  <span className="fw-600 me-2">From:</span>Kosamba,
                  Surat
                </li>
              </ul>
              <a
                href={resumeFile}
                download
                className="btn btn-primary rounded-pill"
              >
                Download CV
              </a>
            </div>
          </div>
          {/* about me personal details end */}
        </div>
        {/* projects rewards counting start */}
        <div
          className={
            "brands-grid separator-border mt-5 " +
            (darkTheme ? "separator-border-light" : "")
          }
        >
          <div className="row">
            <div className="col-6 col-md-3">
              <div className="featured-box text-center">
                <h4
                  className={
                    "text-12  mb-0 " +
                    (darkTheme ? "text-white-50" : "text-muted")
                  }
                >
                  <span>8</span>+
                </h4>
                <p className={"mb-0 " + (darkTheme ? "text-light" : "")}>
                  Years Experiance
                </p>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div className="featured-box text-center">
                <h4
                  className={
                    "text-12  mb-0 " +
                    (darkTheme ? "text-white-50" : "text-muted")
                  }
                >
                  <span>10</span>+
                </h4>
                <p className={"mb-0 " + (darkTheme ? "text-light" : "")}>
                  Happy Clients
                </p>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div className="featured-box text-center">
                <h4
                  className={
                    "text-12  mb-0 " +
                    (darkTheme ? "text-white-50" : "text-muted")
                  }
                >
                  <span>15</span>+
                </h4>
                <p className={"mb-0 " + (darkTheme ? "text-light" : "")}>
                  Projects Done
                </p>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div className="featured-box text-center">
                <h4
                  className={
                    "text-12  mb-0 " +
                    (darkTheme ? "text-white-50" : "text-muted")
                  }
                >
                  <span>4</span>
                </h4>
                <p className={"mb-0 " + (darkTheme ? "text-light" : "")}>
                  Get Awards
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* projects rewards counting end */}
      </div>
    </section>
  );
};

export default AboutUs;
